import { render } from "./MealInput.vue?vue&type=template&id=4347e585&scoped=true&ts=true"
import script from "./MealInput.vue?vue&type=script&lang=ts"
export * from "./MealInput.vue?vue&type=script&lang=ts"

import "./MealInput.vue?vue&type=style&index=0&id=4347e585&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4347e585"]])

export default __exports__